<template>
  <div class="companyAuthInfo">
    <div class="segment-outer">
      <div class="segment statistics">
        <div class="segment-header">营业执照</div>
        <div class="segment-area segment-item-box">
          <el-form
            :model="businessLicenseResponse"
            ref="businessLicenseResponse"
            :rules="rules"
            label-width="164px"
            :label-position="labelPosition"
          >
            <el-form-item label="营业执照：" class="self-brefore">
              <template v-if="stepOneEdit">
                <upLoad-single-pic
                  currentImgName="businessLicenseResponse.photoUploadUrl"
                  :currentImgVal="businessLicenseResponse.photoUploadUrl"
                  @succeed="handleLoadSucceed"
                  @remove="handleRemoved"
                >
                  <template slot="upload-tip">
                    <div class="el-upload__tip">营业执照</div>
                  </template>
                </upLoad-single-pic>
              </template>
              <template v-else>
                <div class="pic-preview">
                  <img :src="urlPrefix + businessLicenseResponse.photoUploadUrl" />
                </div>
              </template>
            </el-form-item>
            <el-form-item label="企业名称：" class="self-brefore" prop="companyName">
              <template v-if="stepOneEdit">
                <el-input
                  v-model.trim="businessLicenseResponse.companyName"
                  auto-complete="off"
                  :maxlength="32"
                  placeholder="输入营业执照上的企业名称"
                ></el-input>

                <el-button
                  v-if="[0, 2].includes(certificateStatus)"
                  type="text"
                  :disabled="!businessLicenseResponse.companyName"
                  class="font-blue pointer ml-5"
                  @click="hanldeGetCompanyInfo"
                  >获取企业信息</el-button
                >
              </template>
              <template v-else>{{ businessLicenseResponse.companyName }}</template>
            </el-form-item>
            <el-form-item label="统一社会信用代码：" class="self-brefore" prop="creditCode">
              <div class="code">
                <template v-if="stepOneEdit">
                  <el-input
                    v-model.trim="businessLicenseResponse.creditCode"
                    auto-complete="off"
                    :maxlength="18"
                    :disabled="![0, 2].includes(certificateStatus)"
                    placeholder="输入营业执照上的注册号/统一社会信用代码"
                  ></el-input>
                </template>
                <template v-else> {{ businessLicenseResponse.creditCode }}</template>
              </div>
            </el-form-item>
            <el-form-item label="注册地址：" class="self-brefore" prop="registerAddress">
              <template v-if="stepOneEdit">
                <el-input
                  v-model.trim="businessLicenseResponse.registerAddress"
                  auto-complete="off"
                  :maxlength="200"
                  placeholder="输入营业执照上的注册地址"
                ></el-input>
              </template>
              <template v-else>{{ businessLicenseResponse.registerAddress }}</template>
            </el-form-item>
            <el-form-item label="法定代表人姓名：" class="self-brefore" prop="corpName">
              <template v-if="stepOneEdit">
                <el-input
                  v-model.trim="businessLicenseResponse.corpName"
                  auto-complete="off"
                  :maxlength="32"
                  placeholder="输入营业执照上的法定代表人姓名"
                ></el-input>
              </template>
              <template v-else>{{ businessLicenseResponse.corpName }}</template>
            </el-form-item>
            <template v-if="stepOneEdit">
              <el-form-item label="营业期限">
                <div>
                  <el-checkbox v-model="businessLicenseResponse.longTermFlag" class="ml-5">长期有效</el-checkbox>
                  <span class="font-gray">如果营业执照上没有标明营业结束日期,请勾选"长期有效"</span>
                </div>
                <div>
                  <el-date-picker
                    v-model="businessLicenseResponse.startDate"
                    type="date"
                    style="width: 205px"
                    value-format="timestamp"
                    :clearable="false"
                    placeholder="选择开始日期"
                  ></el-date-picker>

                  <span>-</span>
                  <el-date-picker
                    :disabled="businessLicenseResponse.longTermFlag"
                    v-model="businessLicenseResponse.endDate"
                    type="date"
                    style="width: 205px"
                    value-format="timestamp"
                    :clearable="false"
                    @change="selectTimeChange"
                    placeholder="选择结束日期"
                  >
                  </el-date-picker>
                </div>
              </el-form-item>
            </template>
            <template v-if="!stepOneEdit">
              <div class="segment-item">
                <span class="name">营业期限开始日期：</span>
                <span class="dec" v-if="businessLicenseResponse.startDate">{{
                  businessLicenseResponse.startDate | stamp2TextDate
                }}</span>
                <span class="dec" v-else>无</span>
              </div>
              <div class="segment-item">
                <span class="name">营业期限结束日期：</span>
                <span class="dec" v-if="businessLicenseResponse.longTermFlag">长期有效</span>
                <template v-else>
                  <span v-if="businessLicenseResponse.endDate">
                    {{ businessLicenseResponse.endDate | stamp2TextDate }}</span
                  >
                  <span v-else>无</span>
                </template>
              </div>
            </template>
          </el-form>

          <div class="btn-group">
            <el-button v-if="stepOneEdit" type="primary" round @click="handleSaveStepOne">保存</el-button>
            <el-button v-if="!stepOneEdit" round @click="handleEditStepOne" class="submit-btn">编辑</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="segment-outer" v-if="!stepOneEdit">
      <div class="segment statistics">
        <div class="segment-header">法人</div>
        <div class="segment-area segment-item-box">
          <el-form
            :model="corpResponse"
            ref="corpResponse"
            :rules="rules"
            label-width="164px"
            :label-position="labelPosition"
          >
            <el-form-item label="身份证照片：" class="self-brefore">
              <div class="idcard" v-if="stepTwoEdit">
                <upLoad-single-pic
                  class="mr-20"
                  currentImgName="corpResponse.idCardFrontImageUrl"
                  :currentImgVal="corpResponse.idCardFrontImageUrl"
                  @succeed="handleLoadSucceed"
                  @remove="handleRemoved"
                >
                  <template slot="upload-tip">
                    <div class="el-upload__tip">上传身份证人像面</div>
                  </template>
                </upLoad-single-pic>

                <upLoad-single-pic
                  currentImgName="corpResponse.idCardBackImageUrl"
                  :currentImgVal="corpResponse.idCardBackImageUrl"
                  @succeed="handleLoadSucceed"
                  @remove="handleRemoved"
                >
                  <template slot="upload-tip">
                    <div class="el-upload__tip">上传身份证国徽面</div>
                  </template>
                </upLoad-single-pic>
              </div>
              <div v-else>
                <img
                  class="mr-10"
                  v-if="urlPrefix + corpResponse.idCardFrontImageUrl"
                  :src="idcardfrontPic"
                  alt=""
                  width="192"
                  height="120"
                />
                <img
                  class="mr-10"
                  v-if="urlPrefix + corpResponse.idCardBackImageUrl"
                  :src="idcardBackPic"
                  alt=""
                  width="192"
                  height="120"
                />
              </div>
            </el-form-item>
            <el-form-item label="法定代表人：" class="self-brefore">
              {{ corpResponse.corpName }}
            </el-form-item>
            <el-form-item label="法定代表人身份证号：" class="self-brefore" prop="identityCard">
              <template v-if="stepTwoEdit">
                <el-input
                  v-model.trim="corpResponse.identityCard"
                  auto-complete="off"
                  :maxlength="30"
                  placeholder="输入营业执照上的法定代表人身份证号"
                ></el-input>
              </template>
              <template v-else>{{ corpResponse.identityCard }}</template>
            </el-form-item>
          </el-form>
          <div class="btn-group">
            <el-button v-if="stepTwoEdit" type="primary" round @click="handleSaveStepTwo">保存</el-button>
            <el-button v-if="!stepTwoEdit" round @click="handleEditStepTwo" class="submit-btn">编辑</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="segment-outer" v-if="!stepOneEdit && !stepTwoEdit && showLetterInfo">
      <div class="segment statistics">
        <div class="segment-header">企业认证-委托书（如需）</div>
        <div class="segment-area segment-item-box">
          <div class="segment-item">
            <span class="name">管理员是否是法人本人：</span>
            <span class="dec" v-if="isCorp">管理员是法人本人</span>
            <span class="dec" v-if="!isCorp">管理员不是法人本人</span>
          </div>
          <div class="segment-item">
            <span class="name">企业委托书：</span>
            <span class="dec" v-if="isCorp">无需上传</span>
            <div v-if="!isCorp">
              <div class="dec font-blue download pointer" @click="handleDownload">点击下载模板</div>
              <upLoad-single-pic
                currentImgName="engagementLetterUrl"
                :currentImgVal="engagementLetterUrl"
                @succeed="handleLoadSucceed"
                @remove="handleRemoved"
              >
                <template slot="upload-tip">
                  <div class="el-upload__tip">上传委托书照片</div>
                </template>
              </upLoad-single-pic>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-bottom" v-if="!stepOneEdit && !stepTwoEdit && letterStatus">
      <el-button round type="primary" @click="handleSubmit">提交审核</el-button>
    </div>

    <!--获取企业信息覆盖提示-->
    <el-dialog
      :visible.sync="reGetCompanyTip"
      title="是否重新获取企业信息？"
      custom-class="tip-dialog"
      :close-on-click-modal="false"
    >
      <p>重新获取企业信息将覆盖已填写信息，是否继续</p>
      <div slot="footer">
        <el-button @click="reGetCompanyTip = false" round>取消</el-button>
        <el-button type="primary" @click="handleSureGet" round>继续</el-button>
      </div>
    </el-dialog>

    <!--校验营业执照信息-->
    <el-dialog :visible.sync="licenseTip" title="温馨提示" custom-class="tip-dialog" :close-on-click-modal="false">
      <p>系统检查到，您提交的以下信息有误，请仔细核对后，再确认提交。</p>
      <div>
        <p v-for="(item, idx) in licenseTipArr" :key="idx">{{ item.errMessage }}</p>
      </div>
      <p class="font-red mt-5 mb-5">注意：企业信息错误将会导致运单无法开票</p>
      <div slot="footer">
        <el-button @click="hanldeSaveLicense" round>继续提交</el-button>
        <el-button type="primary" @click="licenseTip = false" round>返回核对</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { WUYI, vali } from '@/api/common';
import axiosNew from '@/api/axiosNew';
import newApi from '@/api/settings.new.api';
import upLoadSinglePic from '@/components/UploadSinglePic';
import idcardBackPic from '@/assets/img/pic_idcard_bm.png';
import idcardfrontPic from '@/assets/img/pic_idcard_zm.png';
import { getFileUrlPrefix } from '@/utils';
import { isIdCardValid, isNumberLetterValid } from '@fe/form-valid';
export default {
  components: {
    upLoadSinglePic
  },
  data() {
    var vailCompanyName = function (rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入企业名称'));
      } else if (!vali.checkComanyName(value)) {
        callback(new Error('企业名称格式不正确'));
      } else {
        callback();
      }
    };
    var vailCompanyLinkMan = function (rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入法定代表人姓名'));
      } else if (!vali.checkCompanyLinkMan(value)) {
        callback(new Error('法定代表人姓名格式不正确'));
      } else {
        callback();
      }
    };
    return {
      reGetCompanyTip: false,
      licenseTip: false,
      licenseTipArr: [],
      urlPrefix: '',
      labelPosition: 'left',
      idcardBackPic,
      idcardfrontPic,
      certificateStatus: 0, // 认证状态 0未认证 1审核中 2审核未通过 3已认证 4待更新 5更新审核中 6更新申请未通过
      stepOneEdit: true, // 营业执照编辑状态
      stepTwoEdit: true, // 法人编辑状态
      isCorp: false, // 管理员是否是法人
      engagementLetterUrl: '', // 委托书
      showLetterInfo: false,
      //营业执照信息
      businessLicenseResponse: {
        photoUploadUrl: '', // 营业执照照片地址
        creditCode: '', // 统一社会信用代码
        companyName: '', // 企业名称
        registerAddress: '', // 注册地址
        corpName: '', // 法定代表人姓名
        startDate: 0, // 营业期限开始日期
        endDate: 0, // 营业期限结束日期
        longTermFlag: false // 是否长期有效
      },
      // 法人信息
      corpResponse: {
        idCardFrontImageUrl: '', // 身份证照片（人像）
        idCardBackImageUrl: '', // 身份证照片（国徽）
        corpName: '', // 法定代表人姓名
        identityCard: '' // 法定代表人身份证号码
      },
      rules: {
        creditCode: [
          { required: true, message: '请输入统一社会信用代码', trigger: 'blur' },
          {
            validator: isNumberLetterValid,
            params: [18, 18],
            message: '统一社会信用代码格式不正确',
            trigger: 'blur'
          }
        ],
        companyName: [{ required: true, validator: vailCompanyName }],
        registerAddress: [{ required: true, message: '请输入注册地址' }],
        corpName: [{ required: true, validator: vailCompanyLinkMan }],
        identityCard: [
          { required: true, message: '请输入法人身份证号', trigger: 'blur' },
          {
            validator: isIdCardValid,
            message: '身份证号格式不正确',
            trigger: 'blur'
          }
        ]
      }
    };
  },
  watch: {
    'businessLicenseResponse.corpName'(val) {
      if (val) this.corpResponse.corpName = val;
    },
    'businessLicenseResponse.longTermFlag'(val) {
      if (val) this.businessLicenseResponse.endDate = null;
    }
  },
  computed: {
    letterStatus() {
      if (this.isCorp || (!this.isCorp && this.engagementLetterUrl)) {
        return true;
      } else {
        return false;
      }
    }
  },
  async created() {
    this.urlPrefix = await getFileUrlPrefix();
    this.qryLicenseinfo();
  },
  methods: {
    selectTimeChange(val) {
      this.businessLicenseResponse.endDate = val + 8.64e7 - 1000;
    },
    // 查询营业执照信息
    qryLicenseinfo() {
      axiosNew.post(newApi.certificateLicenseinfo).then(res => {
        if (res.data && res.data.creditCode) {
          this.businessLicenseResponse = res.data;
          this.certificateStatus = res.data.certificateStatus;
          this.stepOneEdit = false;
          this.qryCorpinfo();
        } else {
          this.stepOneEdit = true;
        }
      });
    },
    // 查询法人信息
    qryCorpinfo() {
      axiosNew.post(newApi.certificateCorpinfo, {}, { silence: true }).then(res => {
        if (res.data && res.data.identityCard) {
          this.corpResponse = res.data;
          this.stepTwoEdit = false;
          this.qryLetterInfo();
        } else {
          this.stepTwoEdit = true;
        }
      });
    },
    // 查询委托书信息
    qryLetterInfo() {
      axiosNew.post(newApi.letterInfo, {}, { silence: true }).then(res => {
        if (res.data) {
          this.isCorp = res.data.corp;
          this.engagementLetterUrl = res.data.engagementLetterUrl;
          this.showLetterInfo = true;
        }
      });
    },
    // 判断是否要重新获取企业资料
    hanldeGetCompanyInfo() {
      if (this.businessLicenseResponse.companyName.length < 5) {
        this.$message.warning('企业名称长度不能小于5个字符');
        return;
      }
      if (
        this.businessLicenseResponse.creditCode ||
        this.businessLicenseResponse.registerAddress ||
        this.businessLicenseResponse.corpName ||
        this.businessLicenseResponse.longTermFlag ||
        this.businessLicenseResponse.startDate ||
        this.businessLicenseResponse.endDate
      ) {
        this.reGetCompanyTip = true;
      } else {
        this.handleSureGet();
      }
    },
    // 通过社会信用代码查询企业资料
    async handleSureGet() {
      if (this.reGetCompanyTip) this.reGetCompanyTip = false;
      const { data } = await axiosNew.post(newApi.companyInfoByCompanyName, {
        companyName: this.businessLicenseResponse.companyName
      });
      if (!data) {
        this.$confirm('企业名称不存在，请检查是否填写正确。如有疑问，请联系客服', '提示', {
          confirmButtonText: '确定',
          showCancelButton: false,
          type: 'warning'
        })
          .then(() => {})
          .catch(() => {});
      } else {
        this.businessLicenseResponse.creditCode = data.creditCode;
        this.businessLicenseResponse.registerAddress = data.registerAddress;
        this.businessLicenseResponse.corpName = data.corpName;
        this.businessLicenseResponse.startDate = data.startDate;
        this.businessLicenseResponse.endDate = data.endDate;
        this.businessLicenseResponse.longTermFlag = data.longTermFlag;
      }
    },
    // 营业执照编辑
    handleEditStepOne() {
      this.stepOneEdit = true;
    },
    handleSaveStepOne() {
      this.$refs['businessLicenseResponse'].validate(valid => {
        if (valid) {
          if (!this.businessLicenseResponse.photoUploadUrl) {
            this.$message.error('请上传营业执照图片');
            return false;
          }
          if (
            !this.businessLicenseResponse.longTermFlag &&
            (!this.businessLicenseResponse.startDate || !this.businessLicenseResponse.endDate)
          ) {
            this.$message.error('请选择营业期限');
            return false;
          }
          if (
            this.businessLicenseResponse.startDate &&
            this.businessLicenseResponse.endDate &&
            new Date(this.businessLicenseResponse.startDate).getTime() >
              new Date(this.businessLicenseResponse.endDate).getTime()
          ) {
            this.$message.error('开始日期不能大于结束日期');
            return false;
          }
          this.companyLicenseInfoValid();
        }
      });
    },
    // 校验企业营业执照信息
    companyLicenseInfoValid() {
      let options = {
        ...this.businessLicenseResponse,
        startDate: this.businessLicenseResponse.startDate ? this.businessLicenseResponse.startDate : 0,
        endDate: this.businessLicenseResponse.longTermFlag ? 0 : this.businessLicenseResponse.endDate
      };
      axiosNew.post(newApi.companyLicenseInfo, options).then(res => {
        let arr = res.data || [];
        if (arr.length > 0) {
          this.licenseTip = true;
          this.licenseTipArr = res.data;
        } else {
          this.saveCompanyLicense();
        }
      });
    },
    hanldeSaveLicense() {
      this.licenseTip = false;
      this.saveCompanyLicense();
    },
    // 营业执照保存
    saveCompanyLicense() {
      let options = {
        ...this.businessLicenseResponse,
        startDate: this.businessLicenseResponse.startDate ? this.businessLicenseResponse.startDate : 0,
        endDate: this.businessLicenseResponse.longTermFlag ? 0 : this.businessLicenseResponse.endDate
      };
      axiosNew.post(newApi.saveCompanyLicense, options).then(res => {
        this.businessLicenseResponse = res.data;
        this.stepOneEdit = false;
        this.stepTwoEdit = true;
        this.editCorpinfo();
      });
    },
    editCorpinfo() {
      axiosNew.post(newApi.certificateCorpinfo).then(res => {
        if (res.data && res.data.identityCard) {
          this.corpResponse = res.data;
        }
        this.corpResponse.corpName = this.businessLicenseResponse.corpName;
      });
    },
    // 法人编辑
    handleEditStepTwo() {
      this.stepTwoEdit = true;
    },

    handleSaveStepTwo() {
      this.$refs['corpResponse'].validate(valid => {
        if (valid) {
          if (!this.corpResponse.idCardFrontImageUrl) {
            this.$message.error('请上传身份证正面');
            return false;
          }
          if (!this.corpResponse.idCardBackImageUrl) {
            this.$message.error('请上传身份证反面');
            return false;
          }
          this.legalPersonCertify();
        }
      });
    },
    // 法人姓名和身份证验真
    legalPersonCertify() {
      let options = {
        ...this.corpResponse
      };
      axiosNew.post(newApi.legalPersonCertify, options).then(res => {
        this.saveLegalPerson();
      });
    },
    // 法人保存
    saveLegalPerson() {
      let options = {
        ...this.corpResponse
      };
      axiosNew.post(newApi.saveLegalPerson, options).then(res => {
        this.corpResponse = res.data;
        this.isCorp = res.data.corpFlag;
        this.stepTwoEdit = false;
        this.showLetterInfo = true;
      });
    },
    // 提交审核
    handleSubmit() {
      let options = {};
      if (!this.isCorp) {
        options.proxyStatementPhoto = this.engagementLetterUrl;
      }
      axiosNew.post(newApi.companyCertifySave, options).then(res => {
        this.$emit('submit');
      });
    },
    // 委托书下载
    handleDownload() {
      axiosNew.post(newApi.proxyStatementUrl).then(res => {
        window.location.href = this.urlPrefix + res.data.downloadUrl;
      });
    },
    handleLoadSucceed(currentImgObj, cb) {
      const { name, url } = currentImgObj.data;
      const picSource = `${currentImgObj.source}`;
      this.getPicSource(picSource, url);
      if (cb) cb();
    },
    getPicSource(picSource, target) {
      // 几级对象赋值
      let arr = picSource.split('.');
      if (arr.length === 1) {
        this[picSource] = target;
      } else {
        arr.reduce((prev, cur, index, arr) => {
          this[prev][cur] = target;
        });
      }
    },
    handleRemoved(picSource) {
      this.getPicSource(picSource, '');
    }
  }
};
</script>

<style scoped>
.segment-item-box {
  margin: 40px 20px;
}
.segment-item {
  display: flex;
  margin: 20px 0;
}
.segment-item .name {
  width: 164px;
  color: #90a0b1;
}
.segment-item .name.short {
  width: 100px;
}
.download {
  display: inline-block;
  margin-bottom: 10px;
}
.segment-item .dec {
  color: #424b53;
}
.pic-preview {
  width: 192px;
  height: 120px;
  background-size: 100% 100%;
}
.pic-preview img {
  width: 100%;
  height: 100%;
}
.btn-group {
  padding: 30px 10px 0 40px;
  border-top: 1px solid #e8ecef;
}
.submit-btn {
  border: 1px solid #1cc466;
  color: #1cc466;
}
.btn-getinfo {
  display: inline;
}
.idcard {
  display: flex;
}
.btn-bottom {
  margin: 40px;
}
.code {
  display: flex;
  position: relative;
}
</style>
<style>
.companyAuthInfo .self-brefore .el-input {
  width: 386px;
}
/* .companyAuthInfo .self-brefore .el-input__inner {
    width: 386px;
} */
.companyAuthInfo .el-form-item__label {
  color: #90a0b1;
}
</style>
